export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 bg-background-50">
      <div className="max-w-[900px] mx-auto px-6 md:px-10 text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
          Ready to Explore the Latest <span className="italic text-primary-500">Kakobuy Spreadsheet</span>?
        </h2>
        <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
          Join thousands of smart shoppers who use our daily-updated spreadsheet to discover the best products, compare sellers, and shop with confidence.
        </p>
        <div className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-all hover:-translate-y-0.5 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-file-list-3-line text-lg"></i>
            Open Spreadsheet Now
            <i className="ri-arrow-right-line text-lg"></i>
          </a>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border-2 border-primary-500 text-primary-600 font-semibold text-base hover:bg-primary-50 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-shopping-bag-3-line text-lg"></i>
            Buy It Now
          </a>
        </div>

        {/* Bottom product visual row */}
        <div className="mt-12 md:mt-16 flex flex-wrap items-center justify-center gap-3 md:gap-5">
          {['Shoes', 'Clothing', 'Bags', 'Accessories', 'Jerseys', 'Sets'].map((cat, i) => (
            <span
              key={i}
              className="px-4 py-2 rounded-full bg-background-100 text-foreground-700 text-xs md:text-sm font-medium border border-background-200/60 whitespace-nowrap"
            >
              {cat} Spreadsheet
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}